import { PluginFunc } from 'dayjs';
import 'dayjs';

declare module 'dayjs' {
	interface Dayjs {
		toISOStringWithZone(): string;
		transformToBEAcceptanceFormat(): string;
	}
}

const customDayjsPlugin: PluginFunc = (_options, DayjsClass, _dayjsFactory) => {
	DayjsClass.prototype.toISOStringWithZone = function (): string {
		return this.format('YYYY-MM-DDTHH:mm:ssZ');
	};

	// TODO : to be replaced by toIsoStringWithZone
	DayjsClass.prototype.transformToBEAcceptanceFormat = function (): string {
		return this.utc().toISOString();
	};
};

export default customDayjsPlugin;
